import { TextV2 } from '@withjoy/joykit';
import { LayoutAddComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutAddComponentListItem';
import { useCreateNewJsonComponent } from '@website-editor/customComponents/hooks/useJsonBlobStorageUtils';
import React from 'react';
import { Calendar } from '@withjoy/joykit/icons';
import { AdminSidebarComponentProps } from '@website-editor/customComponents/JsonComponent.types';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { GeneralScheduleConfig } from '../GeneralSchedule.config';
import { useNavigationPaneContext } from '@website-editor/context/NavigationPaneContext/NavigationPane.context';
import { useUpdateWebsitePreview } from '@website-editor/hooks/useUpdateWebsitePreview';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { JsonDataContainerFragment } from '@graphql/generated';
import { CUSTOM_PAGE_ACTIONS } from '@website-editor/customComponents/CustomComponents.constants';
import { useTranslation } from '@shared/core';

// Tip:
// This is the grab handle for your component in the sidebar
// while re-ordering components.
export const GeneralScheduleGrabber = (props: AdminSidebarComponentProps) => {
  return (
    <SimpleGrabHandle
      title={'Event Schedule'}
      icon={<Calendar size={32} />}
      {...props}
    ></SimpleGrabHandle>
  );
};

// Tip:
// This is the button that shows in the "Add Content" page
export const GeneralScheduleAdd = (props: AdminSidebarComponentProps) => {
  const { createNewJsonComponent } = useCreateNewJsonComponent(props.eventHandle);
  const { setRefetchQueries } = useCustomComponentStateContext<JsonDataContainerFragment>();
  const { replaceAndNavigateToScreen } = useNavigationPaneContext();
  const { updateWebsitePreview } = useUpdateWebsitePreview();
  const { tq } = useTranslation('generalEventSchedule');

  const handleClick = () => {
    createNewJsonComponent({
      schemaURL: GeneralScheduleConfig.schemaUrl,
      type: GeneralScheduleConfig.componentType,
      initialData: {
        displayType: 'two-column',
      },
      containerId: props.containerId,
      sortOrder: props.componentData?.sortOrder,
    }).then(result => {
      if (result?.containerData?.data) {
        // Request a refetch of the components list to update the left panel
        setRefetchQueries(['PageContainerBySlug']);

        // Then update the preview
        updateWebsitePreview();

        // Finally replace and navigate to ensure proper left panel update
        replaceAndNavigateToScreen(CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS);
      }
    });
  };

  return (
    <LayoutAddComponentListItem onClick={handleClick}>
      <Calendar size={48} />
      <TextV2
        typographyVariant="hed2"
        textAlign="left"
      >
        {tq`Event Schedule`}
      </TextV2>
    </LayoutAddComponentListItem>
  );
};
